interface VibesState {
    targeting?: boolean;
}

declare global {
    interface Window {
        vibesState: VibesState;
    }
}

export const addToVibesState = <T extends VibesState, K extends keyof T>(stateName: K, stateValue: T[K]) => {
    window.vibesState = {
        ...(window.vibesState || {}),
        [stateName]: stateValue,
    };
};

export const initVibesState = () => {
    window.vibesState = {
    };
};